(function () {
    angular
        .module('app')
        .controller('RegisterRoleController', RegisterRoleController);

    // Define controller dependencies.
    RegisterRoleController.$inject = ['$rootScope', '$scope'];

    /**
     * Controller for 'main' view of 'register.role' state.
     *
     * @param $rootScope
     * @param $scope
     * @constructor
     */
    function RegisterRoleController($rootScope, $scope) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            $rootScope.global.pageTitle = 'Register Role';

            $scope.shared.reset();
            $scope.shared.resource = 'role';
            $scope.shared.mainRegisterState = 'register.role';
            $scope.shared.subjectTemplate = 'components/register/role/role-subject.view.html';
        }

        activate();
    }
})();
